module.exports = __webpack_public_path__ + "media/src/images/buttons/twitter-4be837799d3204de0d98ac89c59347fa.svg";